import React from 'react'
import { BsTwitter } from 'react-icons/bs'
import { FaFacebookF, FaLinkedinIn } from 'react-icons/fa'
import { styles } from '../../styles'

const Socials = () => {
  return (
    <article className='flex-col justify-center items-center mmd:flex hidden'>
      {[
        {
          icon: <BsTwitter className={`${styles.socials}`} />,
          id: 'twitter',
          link: 'https://twitter.com/SherlockHom221B',
        },
        {
          icon: <FaLinkedinIn className={`${styles.socials}`} />,
          id: 'linkedIn',
          link: 'https://www.linkedin.com/in/christsanctus-chinedu-a26914241/',
        },
        {
          icon: <FaFacebookF className={`${styles.socials}`} />,
          id: 'facebook',
          link: 'https://www.facebook.com/christsanctus.asogwa.71/',
        },
      ].map((socials, index) => {
        return (
          <div
            key={index}
            className=' bg-white_color w-[40px] h-[40px] rounded-full my-1 flex justify-center items-center transition-all border-2 border-lightGray_color dark:bg-tertiary shadow-lg cursor-pointer'
            onClick={() => window.open(socials.link, '_blank')}
          >
            {socials.icon}
          </div>
        )
      })}
    </article>
  )
}

export default Socials
